// extracted by mini-css-extract-plugin
module.exports = {"button":"skins-largeOnWide-button-8deca976","buttonLoading":"skins-largeOnWide-buttonLoading-2a447b13"};